// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YYpm","top":"styles_top__3HRT-"};